var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconTime4Lwfcuaj78(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:#FFEFE4;}\n\t.st2{fill:#69EBFC;}\n\t.st3{fill:#5FD4E3;}\n\t.st4{fill:#A1F1FC;}\n\t.st5{fill:#D476E2;}\n\t.st6{fill:#B665C2;}\n\t.st7{fill:#EA82FA;}\n\t.st8{fill:#FFF7F2;}\n\t.st9{fill:#FF8354;}\n\t.st10{fill:#FFA172;}\n\t.st11{fill:#6770E6;}\n\t.st12{fill:#5861C7;}\n\t.st13{fill:#E0734A;}\n\t.st14{fill:#EDD4C2;}\n\t.st15{fill:#CC6944;}\n\t.st16{fill:#858EFF;}\n\t.st17{fill:#C76642;}\n\t.st18{fill:#FFFFFF;}\n\t.st19{fill:#FFDEC7;}\n\t.st20{fill:#4E56B0;}\n\t.st21{fill:#94529E;}\n\t.st22{fill:#41B6C5;}\n\t.st23{fill:#9847A4;}\n\t.st24{fill:#C2552C;}\n\t.st25{fill:#CFB6A4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M216.339,254.535L216.339,254.535c-5.222,3.015-11.9,1.226-14.916-3.997l-25.746-44.593l18.912-10.919 l25.746,44.593C223.35,244.842,221.561,251.52,216.339,254.535z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M39.661,254.535L39.661,254.535c5.222,3.015,11.9,1.226,14.916-3.997l25.746-44.593L61.41,195.027 L35.665,239.62C32.65,244.842,34.439,251.52,39.661,254.535z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M42.806,249.351l-2.061-1.19c-2.902-1.675-4.851-4.365-5.662-7.362c-2.143,5.01-0.259,10.944,4.578,13.737v0 c5.222,3.015,11.9,1.226,14.916-3.997l0.846-1.465C51.719,251.427,46.869,251.697,42.806,249.351z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M213.2,249.351l2.061-1.19c2.902-1.675,4.851-4.365,5.662-7.362c2.143,5.01,0.259,10.944-4.578,13.737v0 c-5.222,3.015-11.9,1.226-14.916-3.997l-0.846-1.465C204.288,251.427,209.137,251.697,213.2,249.351z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.133,
    y: 37.799,
    className: "st6",
    width: 7.734,
    height: 14.999
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M63.605,91.819L10.78,38.994V37.13C10.78,16.628,27.408,0,47.847,0h160.307 c9.914,0,19.231,3.865,26.235,10.882c7.004,7.017,10.851,16.342,10.831,26.256l-0.004,1.859l-52.358,52.359l-6.363-6.364 l49.673-49.673c-0.417-6.829-3.271-13.193-8.148-18.079C222.716,11.926,215.66,9,208.153,9H47.847 c-14.89,0-27.107,11.654-28.013,26.32l50.135,50.135L63.605,91.819z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.847,5h160.307c9.914,0,19.231,3.865,26.235,10.882c6.287,6.299,10.02,14.46,10.706,23.236l0.121-0.121 l0.004-1.859c0.02-9.915-3.827-19.239-10.831-26.256C227.385,3.865,218.067,0,208.153,0H47.847C27.408,0,10.78,16.628,10.78,37.13 v1.864l0.132,0.132C12.443,20.029,28.418,5,47.847,5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 128,
    cy: 148,
    r: 99.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 128,
    cy: 148,
    r: 79.356
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 128,
    cy: 148,
    r: 10.816
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 128,
    cy: 83.456,
    r: 4.813
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 128,
    cy: 212.544,
    r: 4.813
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 63.456,
    cy: 148,
    r: 4.813
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 192.544,
    cy: 148,
    r: 4.813
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M82.082,42.303L22.815,101.57c-1.725,1.725-4.522,1.725-6.247,0l-3.427-3.427 c-17.522-17.522-17.522-45.932,0-63.454l2.059-2.059c17.522-17.522,45.932-17.522,63.454,0l3.427,3.427 C83.807,37.782,83.807,40.578,82.082,42.303z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M13.142,39.689l2.059-2.059c17.522-17.523,45.932-17.523,63.454,0l3.427,3.427 c0.194,0.194,0.359,0.405,0.509,0.623c1.187-1.721,1.022-4.092-0.509-5.623l-3.427-3.427c-17.522-17.523-45.932-17.523-63.454,0 l-2.059,2.059C3.744,44.086-0.606,56.615,0.076,68.916C0.666,58.28,5.017,47.814,13.142,39.689z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M173.918,42.303l59.266,59.266c1.725,1.725,4.522,1.725,6.247,0l3.427-3.427 c17.522-17.522,17.522-45.932,0-63.454l-2.059-2.059c-17.522-17.522-45.932-17.522-63.454,0l-3.427,3.427 C172.193,37.782,172.193,40.578,173.918,42.303z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173.918,41.057l3.427-3.427c17.522-17.523,45.932-17.523,63.454,0l2.059,2.059 c8.125,8.125,12.476,18.591,13.066,29.227c0.682-12.301-3.668-24.83-13.066-34.227l-2.059-2.059 c-17.522-17.523-45.932-17.523-63.454,0l-3.427,3.427c-1.531,1.531-1.696,3.902-0.509,5.623 C173.559,41.462,173.724,41.251,173.918,41.057z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.293,37.799h-24.585c-4.682,0-8.478-3.796-8.478-8.478v0c0-4.682,3.796-8.478,8.478-8.478h24.585 c4.682,0,8.478,3.796,8.478,8.478v0C148.77,34.004,144.975,37.799,140.293,37.799z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M115.707,25.844h24.585c3.812,0,7.035,2.516,8.102,5.978c0.244-0.79,0.376-1.63,0.376-2.5 c0-4.682-3.796-8.478-8.478-8.478h-24.585c-4.682,0-8.478,3.796-8.478,8.478c0,0.87,0.132,1.71,0.376,2.5 C108.672,28.36,111.896,25.844,115.707,25.844z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M128,152c-2.209,0-4-1.791-4-4V95.699c0-2.209,1.791-4,4-4s4,1.791,4,4V148C132,150.209,130.209,152,128,152z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M128,154c-1.535,0-3.071-0.586-4.242-1.757c-2.344-2.343-2.344-6.142,0-8.485l28.656-28.656 c2.342-2.343,6.143-2.343,8.484,0c2.344,2.343,2.344,6.142,0,8.485l-28.656,28.656C131.071,153.414,129.535,154,128,154z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconTime4Lwfcuaj78);
export default __webpack_public_path__ + "static/media/reshot-icon-time-4LWFCUAJ78.ed4c1c107f3fc150f7a69cc07ff27830.svg";
export { ForwardRef as ReactComponent };